import comingsoon from '../assets/coming-soon.svg'

export default function ComingSoon(props) {

    return (
        <div className="coming_soon">
            <img src={comingsoon} alt="Coming Soon" />
        </div>
    );
}